import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Button,
  Form,
  Col,
  Row,
  Modal, notification, Card, AutoComplete
} from 'antd'
import _ from 'lodash'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import {singleQuotationFxn, getAgentsFxn, getFinalChangesInInrFxn, reeudoRatesFxn, getFinalChargesFxn} from '../actions'
import { rupeeSymbol, fixed2Digit } from '../../../components/_utils/appUtils'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { listAllUniversities } from '../../university/actions/university'

const { Option } = AutoComplete
const RenderRow = (props) => {
  let { value, label, span } = props
  return (
    <Col span={span}>
      {label}
      <h5 className={'font-weight-600'}>{value}</h5>
    </Col>
  )
}
const AddTxnStudent = (props) => {
  const {
    form: { getFieldDecorator, setFieldsValue, getFieldValue },
    onClose,
    visible,
    onSubmit,
    currencyList,
    sourceId,
    quotationId,
    referenceUserList, currentUser,
    agentId,
    isForexOff,
    exchangeMargin,
    orgExchangeMargin,
    finalChangesState,
    formDataState,
    refreshRateFxn = () => null,
    purposeId,
    countryId
  } = props
  let [selectedCurrencyObj, setSelectedCurrencyObj] = useState({})
  let [quotationData, setQuotationData] = useState(null)
  let [universityList, setUniversityList] = useState([])
  let dispatch = useDispatch()

  useEffect(() => {
    events.apiRequest()
    events.setDefaultValue()
  }, [])

  useEffect(() => {
    if (countryId) {
      loadCountryUniversity(countryId)
    }
  }, [countryId])

  console.log(formDataState, "formDatastate", finalChangesState, "finalchanges state")
  const loadCountryUniversity = async (countryId) => {
    let filters = {
      sortField: 'universityName',
      sortOrder: 'ascend',
      results: 1000000,
      universityCountry: countryId
    }
    let { data } = await dispatch(listAllUniversities(filters))
    if (data) setUniversityList(data)
  }

  const events = {
    // setDefaultAgent: () => {
    //     if (currentUser && currentUser.userType == "agent") {
    //         setAgentId(currentUser._id)
    //     } else {
    //         setAgentId(ryanAgentId)
    //     }
    // },
    setDefaultValue: () => {
      setTimeout(() => {
        setFieldsValue({
          referencedBy: 'NA',
          exchangeMargin: exchangeMargin
        })
      }, 500)
    },

    chooseCurrency: (currency) => {
      let findDoc = _.find(currencyList, (item) => {
        return item.currency == currency
      })
      if (findDoc) {
        setSelectedCurrencyObj(findDoc)
      }
    },
    getFinalCalculateRate: () => {
      return new Promise(async (resolve) => {
        let { data, success } = await dispatch(getFinalChargesFxn(formDataState))
        console.log(data, "data-------------")
        if (success && data && data.charges) {
          resolve({ success: true, data: data.charges })
        } else {
          resolve({ success: false, data: {} })
        }
      })
    },
    refreshModal: () => {
      Modal.info({
        title: 'IBR Rate change, please refresh rate.',
        okText: 'Refresh Now',
        onOk: () => {
          refreshRateFxn()
        }
      })
    },
    apiRequest: () => {
      return new Promise(async (resolve) => {
        let resp = await dispatch(singleQuotationFxn({ quotationId }))
        const response = resp.quotation

        if (response) {
          setQuotationData(response)

          setFieldsValue({
            currency: response.fromCurrency,
            amount: response.amount,
            fxRate: response.fxRate
          })
        }
        resolve({ data: response })
      })
    }
  }


  const inputTypes = {
    fields: [
      {
        key: 'studentName',
        label: 'Student Name',
        required: true,
        placeholder: 'Student Name',
        type: 'text'
      },
      {
        key: 'phoneNumber',
        label: 'Student Mobile Number',
        required: true,
        placeholder: 'Student Mobile Number',
        type: 'text'
      },
      {
        key: 'emailAddress',
        label: 'Student Email Id',
        required: true,
        placeholder: 'Student Email Id',
        type: 'text'
      },
      {
        key: 'panNumber',
        label: 'Pan Number',
        // required: true,
        placeholder: 'Pan Number',
        type: 'text'
      },
      // {
      //   key: 'university',
      //   label: 'University',
      //   required: true,
      //   placeholder: 'Select University',
      //   type: 'select',
      //   options: universityList,
      //   keyAccessor: x => x._id,
      //   valueAccessor: x => x.universityName,
      //   onChange: x => {
      //     setFieldsValue({ university: x })
      //   }
      // },
      {
        key: 'referencedBy',
        label: 'Reference By',
        placeholder: 'Reference By', type: 'select',
        options: referenceUserList,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          // console.log(x);
          setFieldsValue({ referencedBy: x })
        }
      },
      ...(currentUser.userType === 'admin' || currentUser.userType == 'reeudoManager' ? [
        {
          key: 'exchangeMargin', label: 'Exchange Margin', placeholder: 'Exchange Margin', type: 'text'

        }
      ] : [])
    ]
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const forexOffModal = () => {
    Modal.warning({
      title: 'Forex is closed',
      content: (
        <div>
          <p>Forex is Closed, Please try again between 8 a.m. and 4 p.m.</p>
        </div>
      ),
      onOk() {
      }
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isForexOff) {
      forexOffModal()
    } else {
      if (!getFieldValue('university')) {
        notification.warning({ message: 'Please choose/Enter University name.' })
        return
      }
      let { form } = props
      dispatch(showPageLoad())

      let resp = await events.getFinalCalculateRate()
      console.log(resp, "rsppppppppp")
      dispatch(hidePageLoad())
      if (resp) {
        if (finalChangesState.yourRate) {
          nextProcess(finalChangesState.yourRate)
        } else {
          // notification.warning({ message: `Rate change -  old Rate : ${finalChangesState.yourRate},  New Rate : ${data.yourRate}` })
          nextProcess(finalChangesState.yourRate)
          //events.refreshModal()
        }
      } else {
        // events.refreshModal(finalChangesState.yourRate)
      }

      function nextProcess(yourRate) {
        form.validateFields((err, values) => {
          if (!err) {
            if (values.exchangeMargin < orgExchangeMargin) {
              notification.warning({ message: `Sry can't enter less then ${orgExchangeMargin}` })
              return
            }
            const submitValues = {
              ...values,
              sourceId: props.sourceId || '1',
              agentId: agentId,
              purposeId: purposeId || '',
              countryId: countryId,
              yourRate
            }
            const universityName = values.university
            const matchedUni = universityList.find((uni) => universityName && uni.universityName.toLowerCase() === universityName.toLowerCase())

            submitValues.university = matchedUni ? {
              _id: matchedUni._id,
              universityName: matchedUni.universityName
            } : { universityName: universityName }
            onSubmit(submitValues)
          }
        })
      }
    }

  }

  const handleSearch = (inputText) => {
    if (
      inputText &&
      !universityList.some(
        (u) => u.universityName.toLowerCase() === inputText.toLowerCase()
      )
    ) {
      /*const customEntry = {
        _id: `custom-${inputText}`,
        universityName: inputText
      }*/
      setUniversityList((prevList) => [...prevList])
    }
  }

  const handleChange = (val) => {
    // setValue(val);
    setFieldsValue({ university: val })
    // form.setFieldsValue({ university: val }); // Works with antd v3 Form.create()
  }

  return (
    <Modal
      visible={visible}
      title={'Add Quotation'}
      onCancel={onClose}
      width={'45%'}
      footer={null}>
      <>

        <div className='card unizportal'>
          <Form onSubmit={handleSubmit}>
            <Row gutter={24}>
              {inputTypes.fields.map((item, key) => {
                return (
                  <Col span={item.span ? item.span : 12}
                       key={key}>
                    <GetEachFormFields
                      item={item}
                      className={'form-control'}
                      getFieldDecorator={getFieldDecorator}
                      formItemLayout={formItemLayout} />
                  </Col>
                )
              })}

              <Col span={12}>
                <Form.Item label='University'>
                  {getFieldDecorator('university', {
                    rules: [{ required: true, message: 'University is required' }]
                  })(
                    <AutoComplete
                      value={getFieldValue('university')}
                      placeholder='Add University'
                      className={'autoCompleted'}
                      onSearch={handleSearch}
                      onChange={handleChange}
                      filterOption={(inputValue, option) =>
                        option.props.children
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }>
                      {universityList.map((uni) => (
                        <Option key={uni._id || uni.universityName} value={uni.universityName}>
                          {uni.universityName}
                        </Option>
                      ))}
                    </AutoComplete>
                  )}
                </Form.Item>
              </Col>
            </Row>


            <div>

              <Button htmlType='submit' className={'roundBtn'}>
                Submit
              </Button>


            </div>
          </Form>
        </div>
      </>
    </Modal>
  )
}

export default Form.create()(AddTxnStudent)
